const ComputerIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 21.5431 18.8408"
    fill="none"
    {...props}
  >
    <path
      d="M0.75 11.9297H20.7931V11.1797V10.4297H0.75V11.1797V11.9297ZM20.0431 11.1797V18.0908H20.7931H21.5431V11.1797H20.7931H20.0431ZM20.7931 17.3408H0.75V18.0908V18.8408H20.7931V18.0908V17.3408ZM1.5 18.0908V11.1797H0.75H0V18.0908H0.75H1.5ZM3.34302 15.3852H6.8496V14.6352V13.8852H3.34302V14.6352V15.3852ZM17.2643 15.3853H17.2725V14.6353V13.8853H17.2643V14.6353V15.3853ZM14.8125 15.3853H14.8207V14.6353V13.8853H14.8125V14.6353V15.3853ZM12.3607 15.3853H12.3689V14.6353V13.8853H12.3607V14.6353V15.3853ZM9.08149 8.31961C10.2219 7.17917 12.071 7.17917 13.2114 8.31961L13.7417 7.78928L14.2721 7.25895C12.5458 5.53272 9.74706 5.53272 8.02083 7.25895L8.55116 7.78928L9.08149 8.31961ZM6.97503 6.21312C9.27883 3.90932 13.014 3.90932 15.3178 6.21312L15.8481 5.68279L16.3785 5.15246C13.4889 2.26287 8.80396 2.26287 5.91437 5.15246L6.4447 5.68279L6.97503 6.21312ZM4.86413 4.10221C8.33375 0.632596 13.9591 0.632596 17.4287 4.10221L17.959 3.57188L18.4894 3.04155C14.434 -1.01385 7.85887 -1.01385 3.80347 3.04155L4.3338 3.57188L4.86413 4.10221Z"
      fill="currentColor"
    />
  </svg>
);

export default ComputerIcon;
